// extracted by mini-css-extract-plugin
module.exports = {"button":"Paginado_button__2ZmTj","span":"Paginado_span__3NiNG","buttonPrevNext":"Paginado_buttonPrevNext__2Q39N"};